import { merge, Theme } from "theme-ui";
import React from "react";
import { KameleonBase } from "../presets/kameleon-base";

export const themeBuilder = (theme: Theme = {}): Theme => {
  const config: Theme = {
    config: {
      initialColorModeName: "light",
      useRootStyles: true,
      useLocalStorage: false,
    },
  };
  return merge(KameleonBase, merge(config, theme ?? {}));
};

export const KameleonThemeContext: React.Context<Theme> = React.createContext(
  {}
);
